import './PackageRequests.css'

import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Link, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom'

import { usePackageReqs } from '../../../api/package-req'
import backIcon from '../../../imgs/left-arrow.png'
//Icons
import mergeIcon from '../../../imgs/merge.png'
import returnIcon from '../../../imgs/product-return.png'
import shrinkIcon from '../../../imgs/shrink.png'
import OfficeCountryNavBar from '../../../PageComponents/OfficeSide/OfficeCountryNavBar/OfficeCountryNavBar'
import { PackageRequestDataGrid } from './PackageRequestDataGrid'
import { PackageRequestDetails } from './PackageRequestDetails/PackageRequestDetails'

export default function PackageRequests() {
  const { loggedUser } = useSelector(state => state.user)
  const [warehouse, setWarehouse] = useState(loggedUser.permissions['Admin'] ? '' : loggedUser.UserAttributes['custom:warehouse'])
  const { url } = useRouteMatch()
  const location = useLocation()
  const [onlyPending, _setOnlyPending] = useState(true)
  const history = useHistory()
  const params = useParams()
  const selectedReqType = params.reqType
  const selectedReqId = params.reqId
  // Use individual React Query hooks instead of Redux
  const {
    data: packageRequestsData,
    isLoading: isLoadingPackageReqs,
    isError: isErrorPackageReqs,
    error: errorPackageReqs,
    refetch: refetchPackageReqs,
  } = usePackageReqs({ warehouse, onlyPending })

  // Process the data similar to how the Redux slice did it
  const shrinkReqs = packageRequestsData?.shrinkRequest ?? []
  const photoReqs = packageRequestsData?.photoRequest ?? []
  const returnReqs = packageRequestsData?.returnRequest?.filter(returnReq => returnReq.returnLabel) ?? []
  const uniteReqs = packageRequestsData?.uniteRequest ?? []
  const isLoading = isLoadingPackageReqs

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
  }, [])

  const isHeaderShown = !selectedReqId
  // Main PackageRequests component with child routes
  return (
    <div className='package-requests-cmp'>
      {/* Always show OfficeCountryNavBar at the top */}
      {isHeaderShown && (
        <div className='pr-return-cont-container'>
          <div className='pr-return-cont' onClick={() => history.replace('/office-packageRequests')}>
            <div className='pr-return-inner'>
              {!location.pathname.endsWith('office-packageRequests') && (
                <>
                  <img src={backIcon} className='pr-return-img' />
                  <div>Back</div>
                </>
              )}
            </div>
          </div>
          {loggedUser.permissions['Admin'] && <OfficeCountryNavBar warehouse={warehouse} setWarehouse={setWarehouse} anp={false} />}
          <div className='d-flex align-items-center gap-2'>
            {/* <label className='mb-0 '>
              <input
                className='mr-1'
                type='checkbox'
                checked={onlyPending}
                onChange={() => {
                  setOnlyPending(!onlyPending)
                }}
              />
              Only Pending
            </label> */}
            <Button
              className='ml-4'
              size='sm'
              onClick={() => {
                refetchPackageReqs()
              }}
              disabled={isLoadingPackageReqs}
            >
              {isLoadingPackageReqs ? 'Refreshing...' : '🔄 Refresh Data'}
            </Button>
          </div>
        </div>
      )}
      {selectedReqType ? null : isLoading ? (
        <div>
          Loading... <br />
          <Spinner animation='border' variant='primary' />
        </div>
      ) : selectedReqType ? null : (
        <>
          <h1>Package Requests</h1>
          {isErrorPackageReqs && <div>Error loading package requests: {errorPackageReqs?.message || 'Unknown error'}</div>}
          <div className='pr-cards-cont'>
            <div className='pr-card'>
              {uniteReqs?.length > 0 ? (
                <Link to={`${url}/uniteRequest`}>
                  <h3>Unite</h3>
                  <img src={mergeIcon} alt='Unite Icon' />
                  <div className='notification-bubble'>{uniteReqs.length}</div>
                </Link>
              ) : (
                <div className='pr-disabled-link'>
                  <h3>Unite</h3>
                  <img src={mergeIcon} alt='Unite Icon' />
                </div>
              )}
            </div>

            <div className='pr-card'>
              {shrinkReqs?.length > 0 ? (
                <Link to={`${url}/shrinkRequest`}>
                  <h3>Shrink</h3>
                  <img src={shrinkIcon} alt='Shrink Icon' />
                  <div className='notification-bubble'>{shrinkReqs.length}</div>
                </Link>
              ) : (
                <div className='pr-disabled-link'>
                  <h3>Shrink</h3>
                  <img src={shrinkIcon} alt='Shrink Icon' />
                </div>
              )}
            </div>

            <div className='pr-card'>
              {photoReqs?.length > 0 ? (
                <Link to={`${url}/photoRequest`}>
                  <h3>Photo</h3>
                  <span style={{ fontSize: '30px' }}>📷</span>
                  <div className='notification-bubble'>{photoReqs.length}</div>
                </Link>
              ) : (
                <div className='pr-disabled-link'>
                  <h3>Photo</h3>
                  <span style={{ fontSize: '30px' }}>📷</span>
                </div>
              )}
            </div>

            <div className='pr-card'>
              {returnReqs?.length > 0 ? (
                <Link to={`${url}/returnRequest`}>
                  <h3>Return</h3>
                  <img src={returnIcon} alt='Return Icon' />
                  <div className='notification-bubble'>{returnReqs.length}</div>
                </Link>
              ) : (
                <div className='pr-disabled-link'>
                  <h3>Return</h3>
                  <img src={returnIcon} alt='Return Icon' />
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {selectedReqId && <PackageRequestDetails itemId={selectedReqId} />}
      {!selectedReqId && selectedReqType && (
        <PackageRequestDataGrid data={packageRequestsData} reqType={selectedReqType} isLoading={isLoading} />
      )}
      {/* Child routes */}
      {/* <Route path={`${path}/draft-to-regular`}>
          <DraftToRegular warehouse={warehouse} onlyPending={onlyPending} setIsHeaderShown={setIsHeaderShown} />
        </Route> */}
    </div>
  )
}
